import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="mb-8 text-center">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-xl bg-primary text-primary-foreground text-2xl font-bold">
            121
          </div>
          <h1 className="text-2xl font-bold">121PASS Admin</h1>
          <p className="text-muted-foreground">Panel de administración</p>
        </div>

        {/* Content */}
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
